export interface PersonFields {
  full_name: string;
  address_1: string;
  city: string;
  state: string;
  zip: string;
  home_phone?: string;
  work_phone?: string;
  cell_phone: string;
  email?: string;
  ssn: string;
  date_of_birth: string; // API gets a string if I'm not wrong, in date format
  drivers_license: string;
  dl_state: string;
  dl_exp_date: string; // API gets a string if I'm not wrong, in date format
  county: string;
  city_town: string;
}

export interface Form {
  // Customer Info
  customer: PersonFields

  hasCobuyer?: string

  // Cobuyer Info (dropdown yes or no)
  cobuyer: PersonFields

  // Purchace Vehicle Info
  purchase_vehicle: {
    stock_number: string;
    condition: 'new' | 'used' | 'demo';
    year: string;
    make: string;
    model: string;
    body_type?: string;
    color?: string;
    vin: string;
    miles: string;
    warranty?: string;
    in_service_date?: string; // Same thing as the others
  }

  hasTradeVehicle?: string;

  // Trade Vehicle (dropdown yes or no)
  trade_vehicle: {
    year: string;
    make: string;
    model: string;
    body_type?: string;
    color?: string;
    vin: string;
    miles: string;
    tag: string;
  }

  // Insurance Info
  insurance: {
    company?: string;
    street_address?: string;
    city?: string;
    state?: string;
    zip?: string;
    agent?: string;
    phone?: string;
    policy_number: string;
    expiration_date: string;
    deductible?: string;
    full_coverage?: boolean;
  }

  hasPayoff?: string

  // Payoff Info (dropdown yes or no)
  payoff: {
    amount: string;
    good_through: string;
    account_number: string;
    lien_holder_name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
  }

  // Selling Ingo
  selling_info: {
    price: string;
    rebate?: string;
    trade?: string;
    payoff?: string;
    cash_down?: string;
    refund_item?: string;
    refund_value?: string;
    sales_manager_name: string;
    sales_person_name: string;
  }
}

export const initValues: Form = {
  customer: {
    full_name: "",
    address_1: "",
    city: "",
    state: "",
    zip: "",
    home_phone: "",
    work_phone: "",
    cell_phone: "",
    email: "",
    ssn: "",
    drivers_license: "",
    dl_state: "",
    date_of_birth: "",
    dl_exp_date: "",
    county: "",
    city_town: ""
  },
  cobuyer: {
    full_name: "",
    address_1: "",
    city: "",
    state: "",
    zip: "",
    home_phone: "",
    work_phone: "",
    cell_phone: "",
    email: "",
    ssn: "",
    drivers_license: "",
    dl_state: "",
    date_of_birth: "",
    dl_exp_date: "",
    county: "",
    city_town: ""
  },
  purchase_vehicle: {
    stock_number: '',
    condition: "new",
    year: "",
    make: "",
    model: "",
    body_type: "",
    color: "",
    vin: "",
    miles: "",
    warranty: ""
  },
  trade_vehicle: {
    year: "",
    make: "",
    model: "",
    body_type: "",
    color: "",
    vin: "",
    miles: "",
    tag: "",
  },
  insurance: {
    company: "",
    street_address: "",
    city: "",
    state: "",
    zip: "",
    agent: "",
    phone: "",
    policy_number: "",
    deductible: "",
    full_coverage: false,
    expiration_date: ""
  },
  payoff: {
    amount: "0",
    account_number: "",
    lien_holder_name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    good_through: ""
  },
  selling_info: {
    price: "0",
    rebate: "",
    trade: "",
    payoff: "",
    cash_down: "",
    refund_item: "",
    refund_value: "",
    sales_manager_name: "",
    sales_person_name: ""
  }
};
